var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5004 23.0027H2.50586C1.13107 23.0027 0.00624902 21.8779 0.00624902 20.5031C0.00624902 19.1283 1.13107 18.0035 2.50586 18.0035H37.5004C38.8752 18.0035 40 19.1283 40 20.5031C40 21.8779 38.8752 23.0027 37.5004 23.0027Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0031 40.5C19.3532 40.5 18.7283 40.25 18.2284 39.7751L0.731136 22.2778C-0.243712 21.303 -0.243712 19.7282 0.731136 18.7534L18.2284 1.23114C19.2032 0.256288 20.778 0.256288 21.7528 1.23114C22.7277 2.20598 22.7277 3.78074 21.7528 4.75559L6.03031 20.4781L21.7528 36.2007C22.7277 37.1755 22.7277 38.7503 21.7528 39.7251C21.2529 40.225 20.628 40.45 19.9781 40.45L20.0031 40.5Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f42763dd5326cfbad783ecdea000951f.svg";
export { ForwardRef as ReactComponent };